// extracted by mini-css-extract-plugin
module.exports = {"OrderHistoryPage":"OrderHistoryPage","OrderHistoryPage__OrderHistoryList":"OrderHistoryPage__OrderHistoryList"};